import fluxHelper from './helper';
import fluxValidation from './validation';
import fluxStepper from './stepper';
import fluxLoginButtons from './loginButtons';
import fluxAddressSearch from './addressSearch';
import fluxComponents from './components';
import fluxCoupon from './coupon';
import fluxCompatibility from './compatibility';
import fluxCart from './cart';
import fluxForm from './form';
import fluxLocalStorage from './localStorage';
import fluxCheckoutButton from './checkoutButton';
import fluxGeocodeMap from "./geocodeMap";

document.addEventListener( 'DOMContentLoaded', function( event ) { 

    (function () {
        if (typeof Event !== 'function') {
            window.Event = CustomEvent;
        }
    })();

    fluxHelper.removeDomElements();
    fluxValidation.init();
    fluxStepper.init();
    fluxLoginButtons.init();
    fluxAddressSearch.init();
    fluxComponents.init();
    fluxCoupon.init();
    fluxCompatibility.init();
    fluxCart.init();
    fluxCart.runOnce();
    fluxForm.init();
    fluxLocalStorage.init();
    fluxCheckoutButton.init();
    fluxGeocodeMap.init();
} );

( function ( $, document ) {
    $( document ).ready( function() {
        $( document.body ).on( 'wc_fragments_refreshed', function() {
            fluxHelper.removeDomElements();
            fluxCart.init();
            fluxCart.update_total();
        } );
        
        $( document.body ).on( 'updated_checkout', function() {
            fluxHelper.removeDomElements();
            fluxCart.init();
            fluxCart.update_total();
        } );

        $( document.body ).on( 'change', 'input.shipping_method', function() {
            fluxCart.update_total();
        } );
    } );
} )( jQuery, document );